import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@uplift/ui-v2';
import { ProviderInfoCard, ProviderInfoCardProps } from './provider-info-card.component';
import { CardSubtitle } from './card-subtitle.component';


export type KeepOldCardProps = {
  provider: ProviderInfoCardProps['provider'];
  reasons: string[];
  onReject: () => void;
  disabled?: boolean;
};


const useStyles = makeStyles()(theme => ({
  list: {
    color: theme.palette.text.secondary,
    paddingLeft: '1rem',
    margin: 0,
  }
}));


export const KeepOldCard: React.FC<KeepOldCardProps> = (props) => {
  const { classes } = useStyles();

  return (
    <ProviderInfoCard
      provider={props.provider}
      actions={(
        <Button disabled={props.disabled} size="large" variant="outlined" color="secondary" fullWidth onClick={props.onReject}>Keep this therapist</Button>
      )}
    >
      <Box mt={1.5}>
        <CardSubtitle color="primary">Rematch reason</CardSubtitle>
        <ul className={classes.list}>
          {props.reasons.map(r => (
            <li key={r}>{r}</li>
          ))}
        </ul>
      </Box>
    </ProviderInfoCard>
  );
};
